import { CheckCircle2, Circle, FileText, Box } from 'lucide-react'
import type { JourneyPhaseWithMode } from '@ispot/shared'

interface CompactPhaseDetailProps {
  phase: JourneyPhaseWithMode
  isActivityCompleted: (id: string) => boolean
  isArtifactCompleted: (id: string) => boolean
}

export function CompactPhaseDetail({ phase, isActivityCompleted, isArtifactCompleted }: CompactPhaseDetailProps) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 32px' }}>
      <div>
        <div className="font-mono text-text-muted uppercase" style={{ fontSize: 9, letterSpacing: '0.1em', marginBottom: 8 }}>
          Activities ({phase.activities.length})
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {phase.activities.map(a => {
            const done = isActivityCompleted(a.id)
            return (
              <div key={a.id} style={{ display: 'flex', gap: 7, alignItems: 'flex-start' }}>
                {done
                  ? <CheckCircle2 size={12} style={{ color: 'var(--color-market)', marginTop: 1, flexShrink: 0 }} />
                  : <Circle size={12} style={{ color: 'var(--color-border-strong)', marginTop: 1, flexShrink: 0 }} />
                }
                <span style={{ fontSize: 12, lineHeight: 1.4, color: done ? 'var(--color-fg-muted)' : 'var(--color-fg-secondary)', textDecoration: done ? 'line-through' : undefined }}>
                  {a.name}
                  {a.isRequired && <span style={{ color: 'var(--color-danger)', marginLeft: 2 }}>*</span>}
                </span>
              </div>
            )
          })}
        </div>
      </div>

      <div>
        <div className="font-mono text-text-muted uppercase" style={{ fontSize: 9, letterSpacing: '0.1em', marginBottom: 8 }}>
          Artifacts ({phase.artifacts.length})
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {phase.artifacts.map(a => {
            const done = isArtifactCompleted(a.id)
            const icon = a.type === 'canvas'
              ? <Box size={12} style={{ color: phase.color, marginTop: 1, flexShrink: 0 }} />
              : <FileText size={12} style={{ color: phase.color, marginTop: 1, flexShrink: 0 }} />
            return (
              <div key={a.id} style={{ display: 'flex', gap: 7, alignItems: 'flex-start' }}>
                {icon}
                <span style={{ fontSize: 12, lineHeight: 1.4, color: done ? 'var(--color-fg-muted)' : 'var(--color-fg-secondary)', textDecoration: done ? 'line-through' : undefined }}>
                  {a.name}
                  {a.isRequired && <span style={{ color: 'var(--color-danger)', marginLeft: 2 }}>*</span>}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
